<div *ngIf="selecionado">
  <app-pecas-solicitadas-cadastro
    [model]="selecionado"
    (buscar)="buscar($event)"
    [state]="state">
  </app-pecas-solicitadas-cadastro>
</div>
<div *ngIf="!selecionado">
  <app-pecas-solicitadas-filtro [filtros]="filtros"></app-pecas-solicitadas-filtro>
  <app-pecas-solicitadas-lista
    [filtros]="filtros"
    (exibir)="selecionar($event)"
    (definirFiltro)="definirFiltro()">
  </app-pecas-solicitadas-lista>
</div>